import "./utility-tools.css";
import bwipjs from "bwip-js/browser";
import { canvasBlob } from "./bmp-browser.js";
import { createOperationResult } from "./operation-result.js";
import { barcodeInput } from "./utility-tools-core.js";

const root = document.querySelector("[data-barcode-generator]");

if (root) {
  const ids = ["barcodeStatus", "barcodeWorkspace", "barcodePreview", "barcodeType", "barcodeText", "barcodeScale", "downloadBarcodePng", "downloadBarcodeSvg"];
  const elements = Object.fromEntries(ids.map(id => [id, document.getElementById(id)]));
  const result = createOperationResult(root, elements.barcodeWorkspace);

  function status(message = "") { elements.barcodeStatus.textContent = message; elements.barcodeStatus.hidden = !message; }
  function options(scale = Number(elements.barcodeScale.value)) {
    return {
      bcid: elements.barcodeType.value,
      text: barcodeInput(elements.barcodeText.value, elements.barcodeType.value),
      scale,
      height: 18,
      includetext: true,
      textxalign: "center",
      backgroundcolor: "FFFFFF",
      barcolor: "10182B"
    };
  }

  function preview() {
    try {
      bwipjs.toCanvas(elements.barcodePreview, options(2));
      status();
    } catch (error) {
      status(error?.message || "The barcode value is not valid for this type.");
    }
  }

  async function create(type) {
    try {
      const settings = options();
      if (type === "svg") {
        const svg = bwipjs.toSVG(settings);
        result.show({ blob: new Blob([svg], { type: "image/svg+xml" }), fileName: "barcode.svg", message: "Your barcode is ready.", details: [elements.barcodeType.selectedOptions[0].text, "Scalable SVG"], downloadLabel: "Download SVG" });
      } else {
        const canvas = document.createElement("canvas");
        bwipjs.toCanvas(canvas, settings);
        result.show({ blob: await canvasBlob(canvas, "image/png"), fileName: "barcode.png", message: "Your barcode is ready.", details: [elements.barcodeType.selectedOptions[0].text, `${canvas.width} × ${canvas.height} px`], downloadLabel: "Download PNG" });
      }
    } catch (error) {
      status(error?.message || "The barcode could not be generated.");
    }
  }

  elements.barcodeText.addEventListener("input", preview);
  elements.barcodeType.addEventListener("change", preview);
  elements.barcodeScale.addEventListener("change", preview);
  elements.downloadBarcodePng.addEventListener("click", () => create("png"));
  elements.downloadBarcodeSvg.addEventListener("click", () => create("svg"));
  preview();
}
